
import { IChannel } from "../../interfaces/IChannel";
import { useContext, useEffect, useState } from "react";
import { AppMainStateContext } from "../../contexts/AppMainStateContext";
import { DeviceSize } from "../../consts/device";
import NewMovieCard from "../movie-card/NewMovieCard.tsx";

export default function NewMovieGridVertical({ channels, isLoading }: { channels: IChannel[], isLoading: boolean }) {
    const { windowWidth } = useContext(AppMainStateContext);
    const [skeletonItemQuantity, setSkeletonItemQuantity] = useState(5);

    useEffect(() => {
        switch (windowWidth) {
            case DeviceSize.none:
                setSkeletonItemQuantity(5)
                break;
            case DeviceSize.mobile:
                setSkeletonItemQuantity(4);
                break;
            case DeviceSize.mobileL:
                setSkeletonItemQuantity(10);
                break;
            case DeviceSize.tablet:
                setSkeletonItemQuantity(12);
                break;
            case DeviceSize.tabletL:
                setSkeletonItemQuantity(12);
                break;
            case DeviceSize.laptop:
                setSkeletonItemQuantity(20);
                break;
            case DeviceSize.laptopL:
                setSkeletonItemQuantity(25);
                break;
            case DeviceSize.desktop:
                setSkeletonItemQuantity(20);
                break;
        }
    }, []);

    return (
        <>
            <div
                className={`w-full grid gap-5 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5 mt-16 md:mt-4`}>
                {channels.length ?
                    channels.map((item, index) =>
                        <NewMovieCard key={`${item.ch_id}-${index}`} item={item} />

                    )
                    :
                    isLoading ?
                    [...Array(skeletonItemQuantity)].map((_, i) =>
                        <div key={i} className="w-full animate-pulse space-y-1.5">
                            <div className="w-full aspect-video bg-neutral-600 rounded-sm border border-transparent" />
                            <div className="w-1/2 h-4 bg-neutral-600 rounded-full"></div>
                            <div className="w-4/5 h-4 bg-neutral-600 rounded-full"></div>
                        </div>
                    ): <p className="text-neutral-100 font-light">Brak wyników wyszukiwania</p>}
            </div>
        </>
    )
}
